import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { Button } from 'ui/components/common';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToManageTaskSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const createTaskSteps: StepType[] = [
    {
      content: 'Go to the Sales menu tab.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Task to view the Task page.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content:
        'To view the task details, click on the three dots next to the task name.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.MANAGE}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 400);
          },
          false,
        );
      },
      position: 'bottom',
      styles: {
        popover: (base) => ({ ...base, marginTop: 16 }),
      },
      padding: 12,
    },
    {
      content: 'Then select View full details.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.VIEW}"]`,
      disableActions: false,
      position: 'top',
      padding: {
        popover: [12, 0],
      },
    },
    {
      content: (props) => (
        <div {...props}>
          <p>You can review the task details on the right side panel.</p>
          <div className="flex justify-end pt-5">
            <Button
              onClick={() => props.setCurrentStep(props.currentStep + 1)}
              label="NEXT"
            />
          </div>
        </div>
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.DETAILS}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.DETAILS}"]`,
      ],
      stepInteraction: false,
      position: 'left',
    },
    {
      content:
        'To update the task details, click on the three dots next to the task name.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.EDIT}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 300);
          },
          false,
        );
      },
      position: 'left',
      padding: 12,
    },
    {
      content: 'Then select Edit.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.EDIT_DRAFT}"]`,
      position: 'left',
      padding: {
        popover: [12, 0],
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="Make necessary changes to the task by editing the status, due date, priority level, or associated client, and team member."
          type="Edit Task"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.FORM}"]`,
      ],
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(8), 200);
          },
          false,
        );
      },
      stepInteraction: false,
      position: 'left',
      padding: 22,
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.EDIT_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(9), 200);
          },
          false,
        );
      },
      position: 'top',
    },
    {
      content: (props) => (
        <div {...props}>
          <p>You can view all your assigned tasks here.</p>
          <Button
            onClick={() => {
              props.setCurrentStep(props.currentStep + 1);
            }}
            label="NEXT"
            className="mt-5"
          />
        </div>
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.VIEW_UPDATED}"]`,
      position: 'top',
      stepInteraction: false,
      padding: 22,
    },
    {
      content:
        'Mark the task complete by clicking on the checkbox: Mark as Complete.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.MANAGE.COMPLETE_TASK}"]`,
      position: 'top',
      padding: {
        popover: [0, 12],
      },
    },
  ];

  const showManageTaskSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createTaskSteps);
      setIsOpen(true);
    }, 300);
  };

  return showManageTaskSteps;
};

export default useGetHowToManageTaskSteps;
